import { create } from "zustand";

interface ManageAccountModalStore {
  open: boolean;
  openManageAccount: () => void;
  closeManageAccount: () => void;
  setManageAccountOpen: (open: boolean) => void;
}

export const useManageAccountModalStore = create<ManageAccountModalStore>(set => ({
  open: false,
  openManageAccount: () => set({ open: true }),
  closeManageAccount: () => set({ open: false }),
  setManageAccountOpen: open => set({ open }),
}));
